<template>
  <div>
    <cell-icon
      v-if="showType === 'icon'"
      :data="data"
      @chooseItem="chooseItem"
    />
    <cell-text v-else :data="data" @chooseItem="chooseItem" />
    <flip
      v-if="data.length > 0"
      :currentPage="currentPage"
      :totalPage="totalPage"
      @changePage="changePage"
    />
  </div>
</template>

<script>
import CellIcon from "../components/cellIcon";
import CellText from "../components/cellText";
import Flip from "../components/flip";
export default {
  name: "CellList",
  components: { CellIcon, CellText, Flip },
  props: ["showType", "data", "currentPage", "totalPage"],
  methods: {
    changePage(index) {
      this.$emit("changePage", index);
    },
    chooseItem(index) {
      this.$emit("chooseItem", index);
    }
  }
};
</script>
